import { store } from '../store';

export const getTimeToPaywayLinealchannel = ()=>{
    let appKeyTimeLinealchannel = store.getState().metadata?.interval_time_check_lineal_channels;
    if(appKeyTimeLinealchannel === undefined){
        appKeyTimeLinealchannel = ''
    }else {
        appKeyTimeLinealchannel = JSON.parse(appKeyTimeLinealchannel)
    }
    const appKey = {
        default:'60',
    }
    return appKeyTimeLinealchannel || appKey;
}

export const getTimeToEpgChannel = ()=>{
    let appKeyTimeEpgChannel = store.getState().metadata?.minutes_to_wake_up;
    if(appKeyTimeEpgChannel === undefined){
        appKeyTimeEpgChannel = ''
    }else{
        appKeyTimeEpgChannel = JSON.parse(appKeyTimeEpgChannel)
    }
    const appKey = {
        default:{
            minutes: 60,
        }
    }
    return appKeyTimeEpgChannel || appKey;
}

